import { AlertCircle, Check } from 'lucide-react';
import { NavigatePreviousButton } from './NavigatePreviousButton';
import { NavigateNextButton } from './NavigateNextButton';
import { useFormRegistry } from '~/shared/forms/FormRegistryContext';
import { IconButtonPopover } from '~/shared/IconButtonPopover';
import { Button, type ButtonProps } from '~/shared/components/buttons/Button';
import { useVisit } from '../VisitContext';
import { VisitBucketTypeEnum } from '@generated';
import { VisitEvaluationToolbar } from '../evaluations/VisitEvaluationToolbar';

export function VisitTaskFooter({ submitButtonProps }: { submitButtonProps?: ButtonProps }) {
	const { selectedVisitBucket } = useVisit();
	const { totalErrorCount, errorElements, handleSubmit, isSubmitting, hasAnyUnsavedChanges } = useFormRegistry();
	return (
		<>
			<div className="flex space-x-2">
				<NavigatePreviousButton />
				<NavigateNextButton label="Skip" />
			</div>
			<div className="flex items-center space-x-2">
				{selectedVisitBucket.visitBucketTypeId !== VisitBucketTypeEnum.Summary && <VisitEvaluationToolbar />}
				{totalErrorCount > 0 && (
					<IconButtonPopover
						Icon={AlertCircle}
						appearance="outline"
						intent="destructive"
						aria-label={`${totalErrorCount} ${totalErrorCount === 1 ? 'error' : 'errors'}`}
						popoverText={errorElements}
					/>
				)}
			</div>

			<Button
				isPending={isSubmitting}
				isDisabled={!hasAnyUnsavedChanges}
				onClick={handleSubmit}
				Icon={Check}
				label={isSubmitting ? 'Saving' : 'Save'}
				{...submitButtonProps}
			/>
		</>
	);
}
